export const SMTP_PROVIDERS = {
  "g-suite": "google",
  google: "google",
  microsoft: "microsoft",
  datevnet: "microsoft",
  apple: "icloud",
  yahoo: "yahoo",
  proton: "proton",
  unknown: "unknown",
} as const;

const FROM_EMAIL = encodeURIComponent("benachrichtigung@tabula.de");

export const getSniperLink = (smtpProvider: string) => {
  switch (smtpProvider) {
    case SMTP_PROVIDERS.google:
      return `https://mail.google.com/mail/u/0/#search/from%3A(${FROM_EMAIL})+in%3Aanywhere+newer_than%3A1h`;
    case SMTP_PROVIDERS.microsoft:
      return "https://outlook.live.com/mail/0/";
    case SMTP_PROVIDERS.yahoo:
      return `https://mail.yahoo.com/d/search/keyword=from%253A${FROM_EMAIL}`;
    case SMTP_PROVIDERS.apple:
      return "https://www.icloud.com/mail/";
    case SMTP_PROVIDERS.proton:
      return `https://mail.proton.me/u/0/all-mail#from=${FROM_EMAIL}`;
  }
};
